<div [attr.aut-id]="autId" class="spinner">
  <a360-icon icon="spinner" [color]="color" [width]="sizes" [height]="sizes"></a360-icon>
</div>
